module.exports = __webpack_public_path__ + "static/img/quantijingyin.1a1cf77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/quantijingyin.png
// module id = 2L6H
// module chunks = 24